export default function buildYourOwnRechargeBundleController() {
  const bundlesContainer = document.getElementById('build-your-own-recharge-bundle-container');

  if (!bundlesContainer) {
    return;
  }

  const bundlesCart = bundlesContainer.querySelector('#build-your-own-recharge-bundle-cart');
  const rechargeBundles = bundlesContainer.querySelector('#build-your-own-recharge-bundle-recharge');

  const bundlesCartSavingsContainer = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__savings');
  const bundlesCartSavings = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__savings__value');
  const bundlesCartTotal = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__subtotal__value');
  const bundlesCartCheckout = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__checkout');
  const bundlesCartContent = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__content');
  const bundlesCartEmptyMessage = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__content__empty');
  const bundlesCartItemsCount = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__title__count');
  const bundlesCartOpenMobile = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__arrow');

  const bundlesCartFooter = bundlesCart.querySelector('.build-your-own-recharge-bundle-cart__footer');

  let nextStepButton = null;
  let frequencyElement = null;
  let rechargeForm = null;
  let rechargeHeadingContainer = null;
  let bundleProgressElement = null;

  bundlesCartOpenMobile.addEventListener('click', function () {
    bundlesCart.classList.toggle('open');
  });

  function goToNextStep() {
    if (!nextStepButton || nextStepButton.disabled) {
      return;
    }

    nextStepButton.click();
  }

  function recreateFrequencySelect() {
    if (!frequencyElement) {
      return;
    }

    const frequencySelectClone = frequencyElement.cloneNode(true);
    frequencySelectClone.selectedIndex = frequencyElement.selectedIndex;

    bundlesCart
      .querySelector('.build-your-own-recharge-bundle-cart__subscription__title__options')
      .appendChild(frequencySelectClone);

    frequencySelectClone.addEventListener('change', function () {
      frequencyElement.selectedIndex = this.selectedIndex;
      frequencyElement.dispatchEvent(new Event('change'));

      setTimeout(() => {
        modifyRechargeItems();
        syncCartAndRechargeProducts();
      }, 25);
    });
  }

  function syncCartAndRechargeProducts() {
    document.querySelectorAll('.build-your-own-recharge-bundle-cart__item').forEach((cartItem) => {
      const id = cartItem.dataset.rbItemId;

      const rbItem = document.querySelector(`.rb-item[data-rb-item-id="${id}"]`);
      if (!rbItem) {
        cartItem.remove();
      }
    });

    document.querySelectorAll('.rb-item').forEach((rbItem) => {
      handleRbItemQtyChange(rbItem);
    });
  }

  function showBundlesCartFooter() {
    bundlesCartFooter.classList.remove('hidden');
  }

  function hideBundlesCartFooter() {
    bundlesCartFooter.classList.add('hidden');
  }

  function startPriceSync() {
    if (!rechargeHeadingContainer) {
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'childList') {
          return;
        }

        const priceContainer = rechargeHeadingContainer.querySelector('.rb-price');

        if (!priceContainer) {
          hideBundlesCartFooter();
          return;
        }
        showBundlesCartFooter();

        const priceText = priceContainer.textContent;

        const prices = parsePriceText(priceText);

        const savings = prices.discount ? prices.price - prices.discount : 0;
        const total = prices.discount || prices.price;

        bundlesCartSavingsContainer.classList.toggle('hidden', !(savings > 0));

        bundlesCartSavings.textContent = intlFormatMoney(savings, prices.currency);
        bundlesCartTotal.textContent = intlFormatMoney(total, prices.currency);
      });
    });

    observer.observe(rechargeHeadingContainer, {
      childList: true,
      subtree: true,
    });
  }

  function parsePriceText(text) {
    const matches = text.match(/(?:[$€£]?\d{1,3}(?:,\d{3})*(?:\.\d{2})?(?:\s?(?:USD|EUR|GBP))?)/g);
    if (!matches) return null;

    let prices = matches
      .map((match) => {
        const value = parseFloat(match.replace(/[$€£,]/g, ''));
        let currency = match.includes('$') ? 'USD' : match.includes('€') ? 'EUR' : match.includes('£') ? 'GBP' : null;

        if (!currency) {
          if (/USD/.test(text)) currency = 'USD';
          else if (/EUR/.test(text)) currency = 'EUR';
          else if (/GBP/.test(text)) currency = 'GBP';
        }

        return { currency, value };
      })
      .filter((item) => !isNaN(item.value));

    if (prices.length === 0) return null;

    prices.sort((a, b) => b.value - a.value);

    return {
      price: prices[0].value,
      discount: prices.length > 1 ? prices[1].value : null,
      currency: prices[0].currency || 'Unknown',
    };
  }

  function updateTotalSelectedCount() {
    const totalSelectedCount = Array.from(document.querySelectorAll('.rb-item')).reduce((acc, item) => {
      const qtyInput = item.querySelector('.rb-qty-wrapper .rb-input');
      return acc + parseInt(qtyInput.value);
    }, 0);

    bundlesCartItemsCount.textContent = `(${totalSelectedCount} selected)`;
    bundlesCartItemsCount.classList.toggle('hidden', totalSelectedCount === 0);
  }

  function toggleEmptyCartMessage() {
    const isEmpty = bundlesCartContent.querySelectorAll('.build-your-own-recharge-bundle-cart__item').length === 0;

    bundlesCartEmptyMessage.classList.toggle('hidden', !isEmpty);
    bundlesCart.classList.toggle('empty', isEmpty);
  }

  function startNextStepButtonSync() {
    bundlesCartCheckout.addEventListener('click', function () {
      goToNextStep();
    });

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes') {
          return;
        }

        bundlesCartCheckout.disabled = nextStepButton.disabled;
      });
    });

    if (nextStepButton) {
      bundlesCartCheckout.disabled = nextStepButton.disabled;

      observer.observe(nextStepButton, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }
  }

  function startItemsCountSync() {
    document.addEventListener('change', function (event) {
      const item = event.target.closest('.rb-item');

      if (!item) {
        return;
      }

      if (event.target.closest('.rb-input') || event.target.closest('.rb-variant-selector')) {
        handleRbItemQtyChange(item);
      }
    });

    document.addEventListener('click', function (event) {
      const item = event.target.closest('.rb-item');

      if (!item) {
        return;
      }

      if (event.target.closest('.rb-btn-qty-minus') || event.target.closest('.rb-btn-qty-plus')) {
        handleRbItemQtyChange(item);
      }
    });

    document.addEventListener('input', function (event) {
      const item = event.target.closest('.rb-item');

      if (!item) {
        return;
      }

      if (event.target.closest('.rb-input')) {
        handleRbItemQtyChange(item);
      }
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.build-your-own-recharge-bundle-cart__item__remove')) {
        return;
      }

      const item = event.target.closest('.build-your-own-recharge-bundle-cart__item');
      const id = item.dataset.rbItemId;

      const rbItem = document.querySelector(`.rb-item[data-rb-item-id="${id}"]`);
      const qtyInput = rbItem.querySelector('.rb-qty-wrapper .rb-input');
      qtyInput.value = 0;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function modifyRechargeItems() {
    document.querySelectorAll('.rb-item').forEach((item) => {
      const isModified = !!item.querySelector('.rb-product-link');

      if (isModified) {
        return;
      }

      const productId = item.dataset.rbItemId;
      const title = item.querySelector('.rb-title').textContent;

      const product = window.buildYourOwnRechargeBundleProductsData.find((product) => product.id == productId);

      if (!product) {
        return;
      }

      const url = product.url;

      //add link
      const anchorElement = document.createElement('a');
      anchorElement.href = url;
      anchorElement.target = '_blank';
      anchorElement.rel = 'noopener noreferrer';
      anchorElement.classList.add('rb-product-link');
      anchorElement.title = title;

      item.appendChild(anchorElement);

      const ratingHtml = `<div id="product-rating-product-rating-id-${productId}"></div>`;
      const itemContent = item.querySelector('.rb-item-content');
      itemContent.insertAdjacentHTML('afterbegin', ratingHtml);
    });
  }

  function handleRbItemQtyChange(rbItem) {
    const id = rbItem.dataset.rbItemId;
    const qtyInput = rbItem.querySelector('.rb-qty-wrapper .rb-input');
    const priceElement = rbItem.querySelector('.rb-price');

    const qty = parseInt(qtyInput.value) || 0;
    const prices = parsePriceText(priceElement.textContent);

    prices.totalPriceText = intlFormatMoney(prices.price * qty, prices.currency);
    prices.totalDiscountText = intlFormatMoney(prices.discount ? prices.discount * qty : 0, prices.currency);

    if (isItemInCart(id)) {
      if (qty == 0) {
        removeItemFromCart(id);
      } else {
        updateItemInCart(id, qty, prices, rbItem);
      }
    } else if (qty > 0) {
      addItemToCart(id, qty, prices, rbItem);
    }

    toggleEmptyCartMessage();
    updateTotalSelectedCount();

    function isItemInCart(id) {
      return !!getBundlesCartItemById(id);
    }
  }

  function addItemToCart(id, qty, prices, rbItem) {
    const img = rbItem.querySelector('.rb-img img');
    const titleElement = rbItem.querySelector('.rb-title');
    const variantElement = rbItem.querySelector('.rb-variant-selector');

    const title = titleElement.textContent;
    const variantTitle = variantElement ? variantElement?.options[variantElement?.selectedIndex]?.textContent : null;

    const imgUrl = img.src;

    const originalPrice = prices.totalPriceText;
    const discountPrice = prices.totalDiscountText;

    const html = `<div class="build-your-own-recharge-bundle-cart__item" data-rb-item-id="${id}">
        <div class="build-your-own-recharge-bundle-cart__item__image-wrapper">
            <div class="build-your-own-recharge-bundle-cart__item__count">${qty}</div>
            <div class="build-your-own-recharge-bundle-cart__item__image" style="background-image: url(${imgUrl})"></div>
        </div>
        <div class="build-your-own-recharge-bundle-cart__item__details">
            <div class="build-your-own-recharge-bundle-cart__item__header">
                <div class="build-your-own-recharge-bundle-cart__item__title">${title}</div>
                <div class="build-your-own-recharge-bundle-cart__item__variant__title ${
                  variantTitle ? '' : 'hidden'
                }">${variantTitle}</div>
            </div>
            <div class="build-your-own-recharge-bundle-cart__item__footer">
                <div class="build-your-own-recharge-bundle-cart__item__price">
                    <div class="build-your-own-recharge-bundle-cart__item__price--original original ${
                      prices.discount > 0 ? 'old' : ''
                    }">${originalPrice}</div>
                    <div class="build-your-own-recharge-bundle-cart__item__price--discount discount ${
                      prices.discount > 0 ? '' : 'hidden'
                    }">${discountPrice}</div>
                </div>
                <button class="build-your-own-recharge-bundle-cart__item__remove">
                    <span class="visually-hidden">Remove</span>
                </button>
            </div>
        </div>
    </div>
    `;

    bundlesCartContent.insertAdjacentHTML('beforeend', html);
  }

  function updateItemInCart(id, qty, prices, rbItem) {
    const variantElement = rbItem.querySelector('.rb-variant-selector');
    const variantTitle = variantElement ? variantElement?.options[variantElement?.selectedIndex]?.textContent : null;

    const originalPrice = prices.totalPriceText;
    const discountPrice = prices.totalDiscountText;

    const bundlesCartItem = getBundlesCartItemById(id);
    if (!bundlesCartItem) {
      return;
    }

    const bundlesCartItemCount = bundlesCartItem.querySelector('.build-your-own-recharge-bundle-cart__item__count');
    const bundlesCartItemPriceOriginal = bundlesCartItem.querySelector(
      '.build-your-own-recharge-bundle-cart__item__price--original'
    );
    const bundlesCartItemPriceDiscount = bundlesCartItem.querySelector(
      '.build-your-own-recharge-bundle-cart__item__price--discount'
    );
    const bundlesCartItemVariantTitle = bundlesCartItem.querySelector(
      '.build-your-own-recharge-bundle-cart__item__variant__title'
    );

    bundlesCartItemCount.textContent = qty;
    bundlesCartItemPriceOriginal.textContent = originalPrice;
    bundlesCartItemPriceDiscount.textContent = discountPrice;
    bundlesCartItemVariantTitle.textContent = variantTitle;
    bundlesCartItemVariantTitle.classList.toggle('hidden', !variantTitle);

    bundlesCartItemPriceDiscount.classList.toggle('hidden', !(prices.discount > 0));
    bundlesCartItemPriceOriginal.classList.toggle('old', prices.discount > 0);
  }

  function removeItemFromCart(id) {
    const bundlesCartItem = getBundlesCartItemById(id);
    if (!bundlesCartItem) {
      return;
    }
    bundlesCartItem.remove();
  }

  function getBundlesCartItemById(id) {
    return bundlesCartContent.querySelector(`.build-your-own-recharge-bundle-cart__item[data-rb-item-id="${id}"]`);
  }

  function moveBundleProgress() {
    if (!bundleProgressElement) {
      return;
    }

    bundlesCart.insertBefore(bundleProgressElement, bundlesCartContent);
  }

  //work with products
  waitForElement(
    (parent, target) => {
      const rbApp = target.closest('.rb-app');

      if (!rbApp) {
        return;
      }

      nextStepButton = rbApp.querySelector('.rb-form .rb-btn');
      startNextStepButtonSync();

      rechargeForm = rbApp.querySelector('form.rb-form');
      frequencyElement = rbApp.querySelector('.rb-form #selling-plan-list');
      recreateFrequencySelect();

      rechargeHeadingContainer = rbApp.querySelector('.rb-header .rb-container.rb-heading');
      startPriceSync();

      startItemsCountSync();
      modifyRechargeItems();

      bundleProgressElement = rbApp.querySelector('.rb-progress-bar-wrapper');
      moveBundleProgress();
    },
    '#MainContent',
    '#recharge-bundles .rb-form',
    true
  );

  //move bundles to custom bundles container
  waitForElement(
    (parent, target) => {
      rechargeBundles.appendChild(target);
    },
    '#MainContent',
    '#recharge-bundles'
  );
}
